export class ClaimModal {
    init() {
        var self = {
            selectors: {
                modal: "#claimModal",
                modalCloseBtn: "#claimModal .close",
                form: "#newClaimForm",
                formBtn: "#newClaimFormBtn",
                inputContainer: '.claim-modal__input-section',
                errorMsgElement: '.error-message',
                confirmationModal: '#clamConfirmationModal',
                confirmationBtn: '#confirmClaimBtn',
                valueTypeSwicher: '.claim-modal__claim-value-switcher--options .switcher',
                valueTypeInput: '.claim-modal__claim-value-switcher--inputs input'
            },
            validate() {
                let form = $(self.selectors.form)
                let formData = form.serialize();
                let url = form.attr('data-validate');

                $.ajax({
                    type: "POST",
                    url,
                    data: formData
                }).success((data) => {
                    $(self.selectors.confirmationModal).modal('show');
                }).error((data) => {
                    self.handleErrors(data);
                })
            },
            send() {
                let form = $(self.selectors.form)
                let formData = form.serialize();
                let url = form.attr('action');

                $.ajax({
                    type: "POST",
                    url,
                    data: formData
                }).success((data) => {
                    $("body").trigger("addNewClaim");
                    $(self.selectors.modal).modal('hide');
                }).error((data) => {
                    self.handleErrors(data);
                })
            },
            clearErrors() {
                $(self.selectors.inputContainer).removeClass('has-error');
                $(self.selectors.errorMsgElement).html('').hide();
            },
            clearInputs() {
                $(self.selectors.form).find('input[type="text"], input[type="number"], select').val('');
            },
            handleErrors(data) {
                let form = $(self.selectors.form);
                let errorField = form.find(self.selectors.errorMsgElement),
                    errorMsg = JSON.parse(data.responseText);

                $.each(errorMsg, (key, value) => {
                    let element = $('[name="' + key + '"]').closest(self.selectors.inputContainer);

                    if (typeof element !== 'undefined') {
                        element.addClass('has-error')
                    }
                });

                if (data.status == 422) {
                    errorField.html('Please fill all the mandatory fields to proceed.').show();
                    return;
                }

                errorField.html(errorMsg.message).show();
            }
        };

        if ($.fn.datepicker) {
            $('.claim-modal-datepicker').datepicker({
                format: 'yyyy-mm-dd',
                autoclose: true,
            })
        }

        $(self.selectors.confirmationBtn).click(function () {
            $(self.selectors.confirmationModal).modal('hide');

            $.when(
                self.clearErrors()
            ).then(function () {
                self.send();
            });
        })

        $(self.selectors.formBtn).click(function () {
            $.when(
                self.clearErrors()
            ).then(function () {
                self.validate();
            });
        })

        $(self.selectors.modal).on('hidden.bs.modal', function (e) {
            self.clearErrors();
            self.clearInputs();
        })

        $(self.selectors.valueTypeSwicher).click(function () {
            $.when(
                $(self.selectors.valueTypeInput).hide().val("")
            ).then(() => {
                let $type = $(this).attr('data-option');
                $(self.selectors.valueTypeInput + '[name = "' + $type + '"]').show();
            });
        })
    }
}